import { Route } from 'react-router-dom'

const PublicRoute = ({ component: Component, ...rest }: any) => {
  return (
    <Route
      {...rest}
      component={(props: any) => {
        return <Component {...props} />
      }}
    />
  )
}

export default PublicRoute
